<template>
<v-form v-model="valid">
    <v-container>
        <v-row>
            <v-col cols="12" md="12">
                <h1>Centers</h1>

                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="center in centers" :key="center.name">
                                <td>
                                    <a :href="'/center/'+center.rowKey">{{ center.name }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <v-btn color="success" class="mr-4" @click="createCenter">Create New Center</v-btn>
            </v-col>
        </v-row>

        <v-snackbar v-model="showSnackbar" :multi-line="false" :timeout="5000" dark color="#EE765E" class="title">
            {{ snackbarText }}
            <v-btn color="white" text @click="showSnackbar = false">Luk</v-btn>
        </v-snackbar>
    </v-container>
</v-form>
</template>

<script>
// import {    EventBus} from './../../event-bus.js';

import core from "./../../mixins/core";

export default {
    data: function () {
        return {
            centers: false,
            showSnackbar: false,
            snackbarText: "",
            valid: false,
            user: {
                email: "",
                firstName: "",
                lastName: "",
            },
            nameRules: [
                //   v => !!v || 'Name is required',
                //   v => v.length <= 10 || 'Name must be less than 10 characters',
            ],
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+/.test(v) || "E-mail must be valid",
            ],
        };
    },
    mixins: [core],
    mounted() {
        this.getCenters();
    },
    methods: {
        getCenters() {
            this.centers = this.fetchAllCenters().then((centers) => {
                this.centers = centers;
            });
        },
        createCenter() {
            this.serviceCreateCenter().then(() => {
                this.getCenters();
                this.showSnackbar = true;
                this.snackbarText = "Center Created";
            });
        },
    },
    name: "Centers",
};
</script>
